import store from '@/store';
import { isEmpty } from 'lodash';
import { getRoutePathWithHash } from '@/functions/routeUtils';

const getQuery = store.getters['routeQuery/getQuery'];

// Track recent navigations to prevent recursion
const recentNavigations = new Set();
const NAVIGATION_TIMEOUT = 500; // ms

export const storeRouteQuery = async (to, from, next) => {

  // ------------------ HANDLE QUICK NAVIGATION ----------------------
  const navigationKey = `${getRoutePathWithHash(to)}_${JSON.stringify(to.query)}`;

  // If we've recently navigated to this exact route+query combination, skip processing
  if (recentNavigations.has(navigationKey)) {
    return next();
  }

  // Add this navigation to recent set and remove it after a timeout
  recentNavigations.add(navigationKey);
  setTimeout(() => {
    recentNavigations.delete(navigationKey);
  }, NAVIGATION_TIMEOUT);

  // ------------------ HANDLE REDIRECTS ----------------------
  // Check if this is a redirect from the same route
  if (to.redirectedFrom && getRoutePathWithHash(to) === getRoutePathWithHash(to.redirectedFrom)) {
    return next();
  }

  const { query } = to;
  const cachedQuery = getQuery(to);

  //  Don't want to set empty query when navigating from another page, or when redirected from a route guard
  //  Do want to set empty query if navigating from the same page (all queries set to null).

  const hasQuery =
    !isEmpty(query) ||
    (query && getRoutePathWithHash(to) === getRoutePathWithHash(from));

  // Only redirect if we have cached query and current route doesn't have query
  if (!hasQuery && cachedQuery) {
    // Check if we're not just adding empty query parameters
    const redirectKey = `${getRoutePathWithHash(to)}_${JSON.stringify(cachedQuery)}`;
    if (recentNavigations.has(redirectKey)) {
      return next(); // Avoid redirect loop
    }

    return next({ query: cachedQuery, redirect: true });
  }

  if (hasQuery) await store.dispatch('routeQuery/setQuery', to);

  return next();
};
